let Bluebird = require('bluebird')
let {promisify} = Bluebird

let {EventEmitter} = require('events')
let {spawn} = require('child_process')
let http = require('http')

let clone = require('lodash.clone')
let portscanner = require('portscanner')

let findAPortNotInUseAsync = promisify(portscanner.findAPortNotInUse)

function createStartApp(emit) {
  return function startApp(app, port) {
    let env = clone(process.env)
    env.PORT = port
    emit('app-start', app)
    let child = spawn(app.command, app.args, {
      env: env,
      stdio: 'inherit'
    })
    child.on('exit', (code, signal) => {
      emit('app-exit', {
        name: app.name,
        code: code,
        signal: signal
      })
      startApp(app, port)
    })
  }
}

function startApps(apps, searchFromPort, startApp) {
  let appArray = []
  for (let name in apps) {
    let {command, args} = apps[name]
    appArray.push({name, command, args})
  }

  return Bluebird.reduce(appArray, (portMapping, app) => {
    return findAPortNotInUseAsync(searchFromPort, 65535, '127.0.0.1').then(port => {
      startApp(app, port)
      searchFromPort = port + 1
      portMapping[app.name] = port
      return portMapping
    })
  }, {})
}

function startServer(portMapping, port) {
  let text = JSON.stringify(portMapping)

  http.createServer((req, res) => {
    res.writeHead(200, {
      'Content-Type': 'application/json',
      'Content-Length': text.length
    })
    res.end(text)
  }).listen(port)
}

module.exports = class AppHerd extends EventEmitter {
  constructor(config) {
    super()

    this.apps = config.apps
    this.port = config.port || 7000
  }

  emit(...args) {
    super.emit(...args)
    super.emit('all', ...args)
  }

  listen() {
    let {apps, port} = this
    let startApp = createStartApp((...args) => this.emit(...args))
    let searchFromPort = port + 1
    startApps(apps, searchFromPort, startApp).then(portMapping => {
      startServer(portMapping, port)
      this.emit('server-listening', {port})
    })
  }
}
